Page auctionPage
	needsAuth = true

	// Style
	Border	subBoxBorder = {2px solid #e8e8e8}

	// Input fields
	float	directBid = -1
	float	agentLimit = -1
	float	counterOffer

	// UI State
	int[string]	currentImageIndexByKey
	int[string]	lastImageIndexByKey
	bool	showImageOverlay
	bool	showBids
	bool	showCancelationOverlay
	bool[string]	showThumbnailArrowsByKey
	string[]	galleryKeys
	int	overlayImageIndex = 0
	string[]	overlayImages
	string	auctionEndLocal = ""
	float	reviewCurrentPrice = float.notANumber
	string	startAuctionError = ""
	string	cancelationRequestText = ""
	string	cancelationRequestError = ""

	// Data
	Good	good
	Field[]	fields
	Action[]	actions
	Message	popupMessage

	show: string id
		try
			good = await app.goods.subscribeById id
			if good.state == Draft and good.seller == app.user.id then app.navigateTo editPage id; return
			if not Platform.isDebug then await app.actions.add {actionType:ViewAuction, good:id, user:app.user.id}

			html.setTitle "{good.Marke} {good.Modell} - 123womo"
			fields = app.fields.where.showInAuctionPageTable and .showOnEditPage and .showFor.contains(good.Typ)
			fields.orderBy.viewOrder
			if app.user?.userType == Admin
				actions = await app.actions.subscribe "good = '{good.id}'" sort:"created" expand:"user"
			else
				actions = await app.actions.subscribe "good = '{good.id}'" sort:"created"
			galleryKeys = ["main" "damage"]
			currentImageIndexByKey.clear
			lastImageIndexByKey.clear
			showThumbnailArrowsByKey.clear
			for galleryKeys as key
				currentImageIndexByKey[key] = 0
				lastImageIndexByKey[key] = -1
				showThumbnailArrowsByKey[key] = false
			showImageOverlay = false
			overlayImages = []
			overlayImageIndex = 0
			counterOffer = int.notANumber
			showCancelationOverlay = false
			cancelationRequestText = ""
			cancelationRequestError = ""
			auctionEndLocal = ""

			let setLimitAction = app.actions.find.actionType == SetAgentLimit and .good == good.id
			agentLimit = setLimitAction ? setLimitAction.amount : good.currentPrice + app.minimumBidIncrease
			
		catch
			app.navigateTo homePage

	hide
		if good?.id then app.goods.unsubscribe good.id
		app.actions.unsubscribe
	
	tick
		if good and (good.state == Auction or good.state == Negotiation) then refresh
		for galleryKeys as key
			updateThumbnailArrows key
			if currentImageIndexByKey[key] != lastImageIndexByKey[key]
				ensureCurrentThumbnailVisible key
				lastImageIndexByKey[key] = currentImageIndexByKey[key]

	onMessagesChanged
		if not good then return
		let lastMessage = app.messages.items.findLast.good == good.id
			if lastMessage.showPopup and not lastMessage.read
				popupMessage = lastMessage
			else
				popupMessage = null

	draw
		if not good then return
		if showImageOverlay then	drawImageOverlay
		if popupMessage then	drawPopup
		if showCancelationOverlay then	drawCancelationOverlay
		drawContent

	drawImageOverlay
		if not showImageOverlay or overlayImages.length == 0 then return
		overlay
			div width:100%, height:100%, backgroundColor:"rgba(0,0,0,0.9)", display:flex, alignItems:center, justifyContent:center, position:relative
				img Close position:absolute, top:20, right:20, width:80px, cursor:pointer
					onClick:
						showImageOverlay = false
						refresh

				img "{backend.url}/api/files/goods/{good.id}/{overlayImages[overlayImageIndex]}", maxWidth:"90%", maxHeight:"90%", objectFit:contain

				if overlayImages.length > 1
					img Prev, position:absolute, left:20, width:80px, cursor:pointer
						onClick:
							overlayImageIndex = getNextImageIndex overlayImageIndex, overlayImages.length, -1
							refresh

					img Next, position:absolute, right:20, width:80px, cursor:pointer
						onClick:
							overlayImageIndex = getNextImageIndex overlayImageIndex, overlayImages.length, 1
							refresh

	drawPopup
		if not popupMessage then return
		overlay onClickOutside:closePopup
			column backgroundColor:white, padding:32, width:640, minHeight:480, fontFamily:"OpenSans", fontSize:18, position:relative
			alignItems:center, justifyContent:center, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, gap:32
				
				// Close button
				div position:absolute, top:-12, right:-12, width:32, height:32, borderRadius:16, backgroundColor:primaryColor
				cursor:pointer, display:flex, alignItems:center, justifyContent:center, onClick:closePopup
					div "✕", color:white, fontSize:12, fontWeight:bold
				
				column alignItems:center, gap:4, maxHeight:400, overflowY:auto, overflowX:hidden, padding:{top:16}
					div "{popupMessage.created.dayShortMonthNameString} {popupMessage.created.hourMinuteString} Uhr", fontSize:13, color:lightGray
					if popupMessage.subject then div text:popupMessage.subject, fontSize:15, fontWeight:bold, color:secondaryColor
					div popupMessage.text, textAlign:center, padding:{top:8}
	
	closePopup
		if popupMessage then await app.messages.update popupMessage, {read:true}
		popupMessage = null
		refresh

	drawCancelationOverlay
		if not showCancelationOverlay then return
		overlay
			column backgroundColor:white, padding:32, width:400, minHeight:200, fontFamily:"OpenSans", fontSize:18, position:relative
			alignItems:center, justifyContent:center, borderRadius:style.boxBorderRadius, boxShadow:style.boxShadow, gap:32

				div text:"Storno anfragen", fontSize:18, fontWeight:bold, color:#2b3145
				form.text label:"Was ist passiert?", model:cancelationRequestText, rows:10
				if cancelationRequestError
					div text:cancelationRequestError, fontSize:12, color:#ef4444
				app.button "Abschicken", width:100%, isDisabled:cancelationRequestText.trim.length < 10
					onClick:
						cancelationRequestError = ""
						refresh
						string text = cancelationRequestText.trim
						if text.trim.length < 10
							cancelationRequestError = "Bitte beschreiben Sie kurz, was passiert ist."
							refresh
							return
						try
							await backend.post "/api/cancelation-request", {goodId:good.id, text}
							if app.user.id == good.seller then	good.cancelationRequestBySeller = text; else 
							if app.user.id == good.buyer then	good.cancelationRequestByBuyer = text
							cancelationRequestText = ""
							showCancelationOverlay = false
							refresh
						catch as error
							cancelationRequestError = "Stornierung konnte nicht gesendet werden."
							print type:Error "Error sending cancelation request:", error
							refresh
		onClickOutside:
			showCancelationOverlay = false
			cancelationRequestError = ""
			refresh

	drawSubHeader
		div display:flex, justifyContent:center, padding:{top:28 bottom:28}
			div width:100%, display:flex, alignItems:center, gap:12, cursor:pointer, onClick:app.navigateTo buyPage
				div text:"◀", fontSize:20, color:#808080
				div text:"Zurück zu den Suchergebnissen", fontSize:16, color:#40465a

	drawContent
		grid gap:20 gridTemplate:"'img main' 'info info' / 1fr 360px" mobileGridTemplate:"'img' 'main' 'info'" marginTop:32px
			div gridArea:'img' display:flex, flexDirection:column, gap:16, minWidth:0
				drawGallery "main", good.Bilder

			div gridArea:'main' flex:1, backgroundColor:#ffffff, borderRadius:style.boxBorderRadius, padding:{top:32 bottom:32 left:32 right:32}, boxShadow:style.boxShadow, display:flex, flexDirection:column
				app.drawGoodState good
				div text:"{good.Marke} {good.Modell}", fontSize:24, fontWeight:bold, color:#2b3145
				if good.state == Auction and app.user.canSeeAuction
					drawAuction
				else
				if good.state == Negotiation
					drawNegotiation
				else
				if good.state == Review and app.user.userType == Admin
					drawReviewForAdmin
				else
				if good.state == Review and app.user.id == good.seller
					drawReviewForSeller
				else
				if good.state == Sold and (app.user.id == good.buyer or app.user.id == good.seller)
					drawSold
				else
				if good.state == NotSold and (app.user.id == good.seller or app.user.id == good.buyer)
					drawNotSold
				else
				if good.state != NotSold
					drawLastMessage
				else
					drawState

			column gridArea:'info' minWidth:0 gap:16
				if app.user?.userType == Admin then drawHistory
				drawInfo
				drawFooter

	drawGallery: string key, string[] images, bool showMainImage = true, float imageHeight = 72
		int currentIndex = currentImageIndexByKey[key]
		if images.length == 0
			currentIndex = 0
		else
		if currentIndex < 0 or currentIndex >= images.length
			currentIndex = 0
			currentImageIndexByKey[key] = 0
		if showMainImage
			div width:100%, backgroundColor:#f0f0f0, borderRadius:style.boxBorderRadius, position:relative, overflow:hidden, display:flex, alignItems:center, justifyContent:center
				if images.length > 0
					img "{backend.url}/api/files/goods/{good.id}/{images[currentIndex]}", width:100%, cursor:pointer
						onClick:
							openImageOverlay images, currentIndex
				else
					img Placeholder, width:100%, height:100%, objectFit:cover

				if images.length > 1
					img Prev, position:absolute, left:10, width:60px, cursor:pointer
						onClick:
							currentImageIndexByKey[key] = getNextImageIndex currentImageIndexByKey[key], images.length, -1
							refresh

					img Next, position:absolute, right:10, width:60px, cursor:pointer
						onClick:
							currentImageIndexByKey[key] = getNextImageIndex currentImageIndexByKey[key], images.length, 1
							refresh

		if images.length > (showMainImage ? 1 : 0)
			div width:100%, height:(showMainImage ? 80 : imageHeight + 8), position:relative, display:flex, alignItems:center
				string rowId = "auction-thumbnails-row-{key}"
				div id:rowId, width:100%, display:flex, gap:8, overflowX:auto, padding:{bottom:4}, scrollBehavior:"smooth"
					for images as bild
						img "{backend.url}/api/files/goods/{good.id}/{bild}", id:"auction-thumb-{key}-{i}", height:imageHeight, width:auto, maxWidth:imageHeight*2, objectFit:contain
							border:{width:4, style:solid, color:i == currentIndex ? primaryColor : "transparent"}
							cursor:pointer, borderRadius:12px
							onClick:
								currentImageIndexByKey[key] = i
								if showMainImage
									refresh
								else
									openImageOverlay images, i
				if showThumbnailArrowsByKey[key]
					img Prev, position:absolute, left:6, width:28px, cursor:pointer
						onClick:scrollThumbnails key, -1
					img Next, position:absolute, right:6, width:28px, cursor:pointer
						onClick:scrollThumbnails key, 1

	openImageOverlay: string[] images, int index
		overlayImages = images
		overlayImageIndex = index
		showImageOverlay = true
		refresh

	getNextImageIndex: int currentIndex, int imageCount, int direction
		if imageCount <= 0 then return 0
		int nextIndex = currentIndex + direction
		if nextIndex < 0 then return imageCount - 1
		if nextIndex >= imageCount then return 0
		return nextIndex

	updateThumbnailArrows: string key
		HTMLElement row = html.get "auction-thumbnails-row-{key}"
		if not row then return
		bool shouldShow = row.scrollWidth > row.clientWidth + 1
		if shouldShow != showThumbnailArrowsByKey[key]
			showThumbnailArrowsByKey[key] = shouldShow
			refresh

	scrollThumbnails: string key, int direction
		HTMLElement row = html.get "auction-thumbnails-row-{key}"
		if not row
			return
		row.scrollLeft = row.scrollLeft + direction * 180

	ensureCurrentThumbnailVisible: string key
		HTMLElement row = html.get "auction-thumbnails-row-{key}"
		if not row then return
		int currentIndex = currentImageIndexByKey[key]
		HTMLElement thumb = html.get "auction-thumb-{key}-{currentIndex}"
		if not thumb
			return
		float left = thumb.offsetLeft
		float right = left + thumb.offsetWidth
		float viewLeft = row.scrollLeft
		float viewRight = row.scrollLeft + row.clientWidth
		if left < viewLeft
			row.scrollLeft = left
		else if right > viewRight
			row.scrollLeft = right - row.clientWidth

	drawAuction
		if not good then return
		let bids = actions.where.actionType == DirectBid or .actionType == AutomaticBid
		float currentPrice = good.currentPrice
		let minBid = currentPrice + app.minimumBidIncrease

		column gap:24
			app.drawCountdown good
			if bids and bids.length > 0
				div color:lightGray, marginBottom:showBids ? 0 : -16
					let text = bids.length == 1 ? "Es wurde ein Gebot abgegeben" : "Es wurden {bids.length} Gebote abgegeben"
					div text, textDecoration:underline, marginBottom:4, cursor:pointer, onClick:showBids = !showBids; refresh
					if showBids
						grid gridTemplateColumns:"1fr 1fr" gap:4
							for bids as bid
								div "{bid.created.dayShortMonthNameString} {bid.created.hourMinuteString} Uhr"
								div text:(bid.actionType == "AutomaticBid" ? "✨ " : "") + bid.amount.currencyString, textAlign:right			
				
			div display:flex, gap:16, flexWrap:wrap
				drawPrice "Aktueller Preis", currentPrice ? currentPrice.currencyString : "Kein Gebot"
				drawPrice "Preisvorstellung", good.Preisvorstellung ? good.Preisvorstellung.currencyString : "Keine Preisvorstellung"
				drawPrice "Provision", currentPrice ? (currentPrice * app.commissionRate).currencyString : "Keine Provision"

			let message = app.messages.items.findLast.good == good.id and .context == Auction
				drawNegotiationBox message.subject, message.text

			// grid gridTemplateColumns:[1 1], gap:16
			// 	form.number model:directBid, unit:"€", onInput: refresh
			// 	app.button "Bieten", isDisabled:directBid < minBid or good.state != Auction or good.seller == app.user.id
			// 		onClick:
			// 			await backend.post "/api/bid", {goodId:good.id, actionType:"DirectBid", amount:directBid}
			// 			refresh

			column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
				div text:"Mein Bietagent", fontSize:16, fontWeight:bold, color:#2b3145
				let setLimitAction = app.actions.find.actionType == SetAgentLimit and .good == good.id
				if setLimitAction and message and (message.kind == AutoBidToBecomeHighest or message.kind == AutoBidToStayHighest or message.kind == SavedLimitWhileAlreadyHighest)
					div text:"Bietagent aktiv mit einem Limit von {setLimitAction.amount.currencyString}", fontSize:14, color:secondaryColor
				div "Ihr Bietagent wird jedes Gebot automatisch um {app.minimumBidIncrease} € überbieten bis ihr Limit erreicht ist.", fontSize:13
				row gap:8
					div flex:1
						form.number model:agentLimit, unit:"€", onInput: refresh, width:100%
					app.button "-", width:50px, padding:{top:12 bottom:12 left:20 right:20}, isDisabled:agentLimit - app.minimumBidIncrease < minBid, onClick:agentLimit = agentLimit - app.minimumBidIncrease; refresh
					app.button "+", width:50px, padding:{top:12 bottom:12 left:20 right:20}, onClick:agentLimit = agentLimit + app.minimumBidIncrease; refresh
				app.button text:"Bietagenten speichern", width:100%, isDisabled:agentLimit < minBid or good.state != Auction or good.seller == app.user.id
					onClick:
						if agentLimit < minBid
							alert("Ihr Limit muss mindestens {minBid.currencyString} betragen, damit der Bietagent aktiv wird. Bitte prüfen Sie Ihre Eingabe und geben Sie ein höheres Limit ein.")
							return
						if agentLimit >= currentPrice*5
							alert("{agentLimit.currencyString} ist rund das {math.round(agentLimit / currentPrice)}-fache des aktuellen Preises. Bitte prüfen Sie Ihre Eingabe und geben Sie ein geringeres Limit ein.")
							return
						await backend.post "/api/bid", {goodId:good.id, actionType:"SetAgentLimit", amount:agentLimit}
						refresh

	drawNegotiation
		if not app.user then return
		let messages = app.messages.where.good == good.id and .context == Negotiation
		messages.orderBy.created
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			app.drawCountdown good
			for messages[-2..]
				drawNegotiationBox .subject, .text, .price
				if .kind == ReceivedOfferFromBuyer or .kind == ReceivedOfferFromSeller
					string offerMessageId = .id
					bool canDenyOffer = isNegotiationOfferDeniable messages, .
					div display:flex, gap:12
						app.button "Annehmen", width:100%
							onClick:
								await backend.post "/api/negotiate/accept", {goodId:good.id, messageId:offerMessageId}
								refresh
						if canDenyOffer
							app.button "Ablehnen", width:100%
								onClick:
									await backend.post "/api/negotiate/deny", {goodId:good.id, messageId:offerMessageId}
									refresh

			if messages.any.kind == ReceivedOfferFromBuyer or .kind == ReceivedOfferFromSeller or .kind == ReceivedDenyFromBuyer or .kind == ReceivedDenyFromSeller
				// Counter offer
				let lastSentOffer = messages.findLast.kind == SendCounterOfferToBuyer or .kind == SendCounterOfferToSeller
				column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
					div text:"Gegenangebot", fontSize:18, fontWeight:bold, color:#2b3145
					form.number model:counterOffer, unit:"€", onInput: refresh
					string counterError
					if counterOffer.isValidNumber and counterOffer <= good.currentPrice
						counterError = "Ihr Angebot muss höher sein als das Höchstgebot von {good.currentPrice.currencyString}."
					if counterOffer.isValidNumber and lastSentOffer
						if good.seller == app.user.id and counterOffer >= lastSentOffer.price
							counterError = "Ihr neues Angebot muss niedriger als Ihr letztes Angebot sein."
						else
						if good.buyer == app.user.id and counterOffer <= lastSentOffer.price
							counterError = "Ihr neues Angebot muss höher als Ihr letztes Angebot sein."
					if counterError
						div text:counterError, fontSize:12, color:#ef4444

					app.button "Gegenangebot abgeben", width:100%, isDisabled:counterError != ""
						onClick:
							float amount = counterOffer
							counterOffer = float.notANumber
							refresh
							await backend.post "/api/negotiate/counter-offer", {goodId:good.id, amount}
							refresh

			if good.seller == app.user.id and messages.last?.kind == SendDenyToBuyer or messages.last?.kind == ReceivedDenyFromBuyer
				drawReactivateBox

	bool isNegotiationOfferDeniable: Message[] messages, Message offer
		if offer.kind != ReceivedOfferFromBuyer and offer.kind != ReceivedOfferFromSeller then return false
		for messages backwards as message
			if message.id == offer.id then return true
			if message.kind == ReceivedOfferFromBuyer or message.kind == ReceivedOfferFromSeller or message.kind == SendCounterOfferToBuyer or message.kind == SendCounterOfferToSeller or message.kind == SendDenyToBuyer or message.kind == SendDenyToSeller
				return false
		return false

	drawNegotiationBox: string title, string text, float price = 0, bool isSecondary = false
		div border:subBoxBorder, borderRadius:12, padding:{top:14 bottom:14 left:16 right:16}
			backgroundColor:isSecondary ? style.veryLightGray : white
			column gap:8
				div text:title, fontSize:18, fontWeight:bold, color:#2b3145
				if price > 0
					div text: price.currencyString, fontSize:28, fontWeight:bold, color:secondaryColor
				div text, fontSize:14, color:#2b3145

	drawReviewForAdmin
		if not app.user or app.user.userType != Admin then return
		if not good then return

		if not auctionEndLocal
			float serverNow = Time.now + app.serverTimeOffset
			float nextFullHour = math.ceil(serverNow / 3600000) * 3600000
			Date dt = Date.fromTime(nextFullHour + 48 hours)
			if dt.hour < 10
				dt = Date.fromValues dt.year, dt.month, dt.day, 10, 0
			else if dt.hour > 16
				Date nextDay = dt + 24 hours
				dt = Date.fromValues nextDay.year, nextDay.month, nextDay.day, 10, 0
			auctionEndLocal = "{dt.dayMonthYearString} {dt.twoDigitHour}:{dt.twoDigitMinute} Uhr"
		if not reviewCurrentPrice.isValidNumber
			reviewCurrentPrice = good.Preisvorstellung * .75

		column gap:16
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, gap:16
				drawPrice "Preisvorstellung", good.Preisvorstellung ? good.Preisvorstellung.currencyString : "Keine Preisvorstellung"
				form.text label:"Auktionsende", model:auctionEndLocal
					help:"Format: 31.12.2025 23:59 Uhr (lokale Zeit)"
				form.number label:"Startpreis", model:reviewCurrentPrice, unit:"€", onInput: refresh
				if startAuctionError
					div text:startAuctionError, fontSize:12, color:#ef4444
				app.button "Bearbeiten", width:100%, isDisabled:good.state != Review, onClick:app.navigateTo editPage good.id
				app.button "Auktion starten", width:100%, isDisabled:good.state != Review
					onClick:
						startAuctionError = ""
						refresh
						try
							string s = auctionEndLocal.trim
							if s.endsWith(" Uhr")	then s = s[..-4]
							else if s.endsWith("Uhr")	then s = s[..-3]
							s = s.trim
							string[] parts = s.split(" ")
							if parts.length < 2
								startAuctionError = "Bitte geben Sie Datum und Uhrzeit an."
								refresh
								return
							string[] d = parts[0].split(".")
							string[] t = parts[1].split(":")
							if d.length < 3 or t.length < 2
								startAuctionError = "Ungültiges Format. Beispiel: 31.12.2025 23:59 Uhr"
								refresh
								return
							int day = cast d[0]
							int month = cast d[1]
							int year = cast d[2]
							int hour = cast t[0]
							int minute = cast t[1]
							Date utc = Date.fromValues year, month, day, hour, minute
							await backend.post "/api/start-auction", {goodId:good.id, auctionEndTime:utc.utcString, currentPrice:reviewCurrentPrice}
							refresh
						catch as error
							startAuctionError = "Auktion konnte nicht gestartet werden."
							print type:Error "Error starting auction:", error
							refresh

	drawSold
		drawLastMessage
		column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, margin:{top:16px}, gap:16
			TimeString pickupDate = app.user.id == good.seller ? good.pickupDateBySeller : good.pickupDateByBuyer
			if pickupDate
				div text:"{good.Typ} wurde abgeholt", fontSize:14, color:lightGray
			else
				app.button "{good.Typ} wurde abgeholt", width:100%
					onClick:
						try
							await backend.post "/api/pickup", {goodId:good.id}
							refresh
						catch as error
							print type:Error "Error picking up good:", error
							refresh
			string hasRequest = app.user.id == good.seller ? good.cancelationRequestBySeller : good.cancelationRequestByBuyer
			if hasRequest
				div text:"Stornierung wurde angefragt", fontSize:14, color:lightGray
			else
				app.button "Storno anfragen", width:100%
					onClick:
						showCancelationOverlay = true
						cancelationRequestText = ""
						cancelationRequestError = ""
						refresh

	drawNotSold
		if not app.user then return
		drawLastMessage
		if app.user.id == good.seller then drawReactivateBox

	drawReactivateBox
		// Change asking price and restart auction
		column border:subBoxBorder, borderRadius:8, padding:{top:16 bottom:16 left:16 right:16}, margin:{top:16px}, gap:16
			div text:"Inserat erneut aktivieren", fontSize:18, fontWeight:bold, color:#2b3145
			form.number label:"Preisvorstellung anpassen", model:good.Preisvorstellung, unit:"€", onInput: refresh
			app.button "Erneut aktivieren", width:100%, isDisabled: not good.Preisvorstellung.isValidNumber or good.Preisvorstellung <= 0
				onClick:
					await backend.post "/api/ready-for-review", {goodId:good.id, Preisvorstellung:good.Preisvorstellung}
					refresh

	drawLastMessage
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			let message = app.messages.items.findLast.good == good.id
				drawNegotiationBox message.subject, message.text, message.price

	drawReviewForSeller
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray
			let message = app.messages.items.findLast.good == good.id
				drawNegotiationBox message.subject, message.text, message.price
			app.button "Bilder hinzufügen", width:100%, onClick:app.navigateTo editPage good.id

	drawState
		if not app.user then return
		column gap:24
			div app.goodStateNames[good.state], fontSize:13, color:lightGray

	drawPrice: string label, string value
		div display:flex, flexDirection:column
			if label then div text:label, fontSize:14, color:#7a8195
			div text:value, fontSize:20, fontWeight:bold, color:secondaryColor

	drawHistory
		if not actions then return
		app.box
			div fontSize:35, marginBottom:16, text:"Verlauf für Administratoren"
			grid gridTemplateColumns:"140px 85px 1fr 220px 80px" gap:4
				for actions as action
					div "{action.created.dayShortMonthNameString} {action.created.hourMinuteString} Uhr"
					div action.user == "" ? "System" : action.user == good.seller ? "Verkäufer" : action.user == good.buyer ? "Käufer" : ""
					div action.expand?.user?.name or ""	
					div app.actionTypeNames[action.actionType]
					div action.amount ? action.amount.currencyString : "", textAlign:right

	drawInfo
		column gap:style.gapBetweenBoxes width:100%
			fields.eachDistinct.section as section, items
				app.box
					div fontSize:35, marginBottom:16, text:section
					switch section
						"Beschreibung"
							div good[items.first.fieldName].replaceAll("\n", "<br>")
						"Ausstattung"
							row flexWrap:wrap, gap:8
								for items
									if good[.fieldName]
										div text:.name backgroundColor:primaryColor, color:white, padding:{5 12}, borderRadius:16, fontSize:12
						default
							div columnCount:isMobile ? 1 : 2, gap:style.gapBetweenBoxes
								for items
									row marginBottom:8px gap:16px
										let name = .name
										if name == "readyForPickupTime" then name = .description
										div text:name width:190px
										string valueString = good[.fieldName]
										if .dataType == "toggle" then	valueString = valueString ? "Ja" : "Nein"
										if .dataType == "date" and valueString then	valueString = Date(valueString).dayMonthYearString
										div "{valueString} {.unit}"
	
				if section == "Zustand" and (good.Bilder_der_Maengel or good.Maengel)
					app.box
						div fontSize:35, marginBottom:16, text:"Mängel"
						div good.Maengel.replaceAll("\n", "<br>"), marginBottom:8px
						div width:100%, display:flex, flexDirection:column
							drawGallery "damage", good.Bilder_der_Maengel, showMainImage:false, imageHeight:100

	drawBox: string title, string body
		if not body then return
		app.box
			div fontSize:35, marginBottom:16, text:title
			div text:body, fontSize:14

	drawFooter
		div width:100%, border:{1px solid #e5e9f2}, borderRadius:8, padding:{top:16 bottom:16 left:20 right:20}, display:flex, alignItems:center, gap:16, backgroundColor:#ffffff
			div text:"i", width:24, height:24, borderRadius:12, backgroundColor:"#0098da", color:#ffffff, fontSize:16, fontWeight:bold, display:flex, alignItems:center, justifyContent:center, flexShrink:0
			div fontSize:14, color:#2b3145, fontStyle:italic
				span text:"Alle Inseratsdaten basieren ausschließlich auf Angaben des Verkäufers und können fehlerhaft sein."
